import { render, staticRenderFns } from "./OppotunityTabsDetails.vue?vue&type=template&id=05a6606e"
import script from "./OppotunityTabsDetails.vue?vue&type=script&lang=js"
export * from "./OppotunityTabsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports